import { render } from "./QueueList.vue?vue&type=template&id=19cd6af4&scoped=true&ts=true"
import script from "./QueueList.vue?vue&type=script&lang=ts"
export * from "./QueueList.vue?vue&type=script&lang=ts"

import "./QueueList.vue?vue&type=style&index=0&id=19cd6af4&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cd6af4"]])

export default __exports__